import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { Jurisdiction } from "src/app/models/Jurisdiction.model";
import { JurisdictionService } from "src/app/services/jurisdiction.service";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { ColumnSpan } from "src/app/shared/form/columnSpan.model";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import {
    CheckboxFormField,
    FormField,
    TextFormField,
} from "src/app/shared/form/formField.model";
import { ILookup } from "src/app/shared/form/lookup.model";
import nameOf from "src/app/shared/form/nameOf.helper";

@Component({
  standalone: false,
    selector: "app-jurisdiction-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class JurisdictionDialogComponent
    extends FormComponent<Jurisdiction>
    implements OnInit
{
    organizationLevels: ILookup[];
    fields: FormField[];

    constructor(
        dialogRef: MatDialogRef<JurisdictionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
        jurisdictionService: JurisdictionService,
        private organizationLevelService: OrganizationLevelService,
        protected injector: Injector,
    ) {
        super(dialogRef, jurisdictionService, data, "Jurisdiction", injector);
    }

    ngOnInit(): void {
        this.isFormLoading = true;
        forkJoin({
            entity: this.getEntity(),
            organizationLevels: this.organizationLevelService.getAll(),
        }).subscribe(
            (result) => {
                this.entity = result.entity;
                this.organizationLevels = result.organizationLevels;
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    getNewObject(): Jurisdiction {
        return new Jurisdiction();
    }

    validate(): boolean {
        return true;
    }

    initFields(): void {
        this.fields = [
            new TextFormField({
                property: nameOf<Jurisdiction>((x) => x.name),
                name: "Jurisdiction Name",
                columnSpan: new ColumnSpan(1, 1),
            }),
            new CheckboxFormField({
                property: nameOf<Jurisdiction>(
                    (x) => x.applyPressureCorrection,
                ),
                name: "Apply Pressure Correction",
                required: false,
                columnSpan: new ColumnSpan(1, 1),
            }),
        ];
    }
}
